<template>
    <div>
        <div class="mb-4">
            Forgot your password? No problem. Just let us know your email
            address and we will email you a password reset link that will allow
            you to choose a new one.
        </div>

        <div v-if="status" class="mb-4">
            {{ status }}
        </div>

        <form @submit.prevent="submit">
            <text-field
                label="Email"
                type="email"
                v-model="form.email"
                required
                autofocus
                autocomplete="username"
            />

            <div class="flex items-center justify-end mt-4">
                <v-btn
                    :disabled="form.processing"
                    :loading="form.processing"
                    type="submit"
                >
                    Email Password Reset Link
                </v-btn>
            </div>
        </form>
    </div>
</template>

<script>
import BreezeGuestLayout from "@/Layouts/GuestLayout";
import TextField from "../../Components/Forms/TextField";

export default {
    layout: BreezeGuestLayout,

    components: {
        TextField
    },

    props: {
        status: String,
    },

    data() {
        return {
            form: this.$inertia.form({
                email: "",
            }),
        };
    },

    methods: {
        submit() {
            this.form.post(this.route("password.email"));
        },
    },
};
</script>
